<template>
    <div class="bank-card-component">
        <el-form ref="bankInfo" :model="bankInfo" size="small" label-width="110px" :rules="bankRules">
            <el-form-item label="账号类型" prop="collectionType">
                <el-radio-group v-model="bankInfo.collectionType"  @change="handleClearValite">
                    <el-radio :label="0">对私账号(普通银行卡)</el-radio>
                    <el-radio :label="1">对公账号</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="企业名称" v-if="bankInfo.collectionType == 1" prop="companyName">
                <el-input v-model="bankInfo.companyName" placeholder="企业名称" style="width: 300px"></el-input>
            </el-form-item>
            
            <el-form-item label="银行" prop="bankName">
                <el-select v-model="bankInfo.bankName" placeholder="请选择银行" style="width: 300px" @change="handleSelectBank" popper-class="popper-class">
                    <el-option v-for="(item,key) in bankList" :key="key" :value="item.bankTypeName" :label="item.bankTypeName">{{item.bankTypeName}}</el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="网点信息" prop="branchInfo">

                <el-select :popper-append-to-body="false" v-model="bankInfo.branchInfo" clearable filterable remote placeholder="请搜索网点信息" :remote-method="getBranchList" :loading="loading" style="width: 300px">
                    <el-option v-for="item in branchList" :key="item.bankName" :value="item.bankName">{{item.bankName}}</el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="bankInfo.collectionType ? '企业银行卡号' : '银行卡号'"  prop="bankCardNo">
                <el-input v-model="bankInfo.bankCardNo" style="width: 300px" @blur="checkBankNumber"></el-input>
            </el-form-item>

            <el-form-item label="身份证号" prop="bankIdentityNo">
                <el-input v-model="bankInfo.bankIdentityNo" style="width: 300px"></el-input>
            </el-form-item>
            <el-form-item label="手机号码" prop="bankPhone">
                <el-input v-model="bankInfo.bankPhone" style="width: 300px"></el-input>
            </el-form-item>
            
            <el-form-item label="真实名称" prop="bankUserName">
                <el-input v-model="bankInfo.bankUserName" style="width: 300px"></el-input>
            </el-form-item>
        </el-form>

        <div class="footer" style="margin:0 20px;text-align:center;">
            <el-button type="primary" size="small" :loading="isLoading" @click="handleConfirmCard('bankInfo')">提交</el-button>
            <el-button type="text" @click="handleResetForm">重置</el-button>
        </div>
    </div>
</template>


<script>
export default {
    data() {
        var validatebankPhone = (rule, value, callback) => {
            if (!/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(value)) {
                callback(new Error('手机号格式错误且不能为空'));
            } else {

                callback();
            }
        };
        var validateCard = (rule, value, callback) => {
            if (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value)) {
                callback(new Error('身份证号格式错误且不能为空'));
            } else {

                callback();
            }
        };
        return {
            loading: false,
            isLoading: false,
            bankInfo: {
                bankCardNo: "",
                bankIdentityNo: "",
                bankPhone: "",
                bankUserName: "",
                bankCode: "",
                bankName: "",
                collectionType: 0,
                companyName: "",
                branchInfo: ''
            },
            bankRules: {
                companyName: [{ required: true, message: '企业名称不能为空', trigger: 'blur' }],
                bankName: [{ required: true, message: '银行不能为空', trigger: 'blur' }],
                bankCardNo: [{ required: true, message: '银行卡号不能为空', trigger: 'blur' }],
                bankIdentityNo: [{ required: true, validator: validateCard, trigger: 'blur' }],
                bankPhone: [{ required: true, validator: validatebankPhone, trigger: 'blur' }],
                bankUserName: [{ required: true, message: '真实名字不能为空', trigger: 'blur' }],
                branchInfo: [{ required: true, message: '网点信息不能为空！', trigger: 'blur' }],
            },
            bankList: [],
            branchList: []
        }
    },
    created() {
        this.getCardInfo();
        this.getBankTypeList();
    },
    methods: {
        /**
             * 保存
             */
        handleConfirmCard(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.isLoading = true;

                    // if(this.bankInfo.collectionType == 0) {
                    //     this.checkBankNumber();
                    // } else {
                    this.handleChangeBank();

                    // }
                }
            })
        },
        checkBankNumber() {//校验银行卡号
            this.getRequest('/bankCardNo/validateAndCacheCardInfo', {
                cardNo: this.bankInfo.bankCardNo
            }).then(res => {
                let data = res.data;
                this.isLoading = false;
                if (data.data.validated) {
                    if (data.data.bank != this.bankInfo.bankCode) {
                        this.$message.warning("不支持该银行提现，请更换银行卡号！")
                    }

                } else {
                    this.$message.warning("银行卡格式错误");
                }
            })
        },
        handleSelectBank(val) {
            this.bankInfo.bankName = this.bankList.filter(item => item.bankTypeCode == val)[0].bankTypeName;
        },
        handleChangeBank() {//修改银行卡信息
            if(!this.bankInfo.id) {
                this.postRequest("/bankCard/add", this.bankInfo)
                .then(res => {
                    let data = res.data;

                    this.isLoading = false;
                    if (data.code == 200) {//已绑定银行卡
                        this.$message.success(data.msg);
                        this.getCardInfo();
                    }
                })
            } else {
                this.postRequest("/bankCard/edit", this.bankInfo)
                .then(res => {
                    let data = res.data;

                    this.isLoading = false;
                    if (data.code == 200) {//已绑定银行卡
                        this.$message.success(data.msg);
                        this.getCardInfo();
                    }
                })
            }
        },
        handleClearValite() {
            this.bankInfo.companyName = "";
            this.bankInfo.bankCode = "";
            this.bankInfo.bankName = "";
            this.bankInfo.branchInfo = "";
        },
        handleResetForm() {
            this.getCardInfo();
        },
        /**
         * 获取银行列表
         */
        getBranchList(queryString) {
            this.getRequest(`/bankCard/searchBankCode?bankTypeName=${this.bankInfo.bankName}&searchName=${queryString}`)
            .then(res => {
                let data = res.data;

                // console.log(res)
                if(data.code == 200) {
                    this.branchList = data.data;
                } else {
                    this.$message.warning(data.msg);
                }
            })
        },
        /**
         * 获取银行列表
         */
        getBankTypeList() {
            this.getRequest(`/bankCard/getBankType`)
            .then(res => {
                let data = res.data;

                if(data.code == 200) {
                    this.bankList = data.data;
                }
            })
        },
        /**
         * 获取绑定的银行卡信息
         */
        getCardInfo() {
            this.getRequest("/bankCard/getBank")
            .then(res => {
                let data = res.data;

                data.data.collectionType = data.data.collectionType || 0;
                data.data = data.data ? data.data : {
                    bankCardNo: "",
                    bankIdentityNo: "",
                    bankPhone: "",
                    bankUserName: "",
                    bankCode: "",
                    bankName: "",
                    collectionType: 0,
                    companyName: "",
                    branchInfo: ''
                }
                if(data.code == 200) {//已绑定银行卡
                    this.bankInfo = data.data;
                } else if(data.code == 402) {
                    this.$alert(data.msg, '提示', {
                        confirmButtonText: '确定',
                    });
                    this.bankInfo = data.data;
                } else {
                    this.bankInfo =  {
                        bankCardNo: "",
                        bankIdentityNo: "",
                        bankPhone: "",
                        bankUserName: "",
                        bankCode: "",
                        bankName: "",
                        collectionType: 0,
                        companyName: "",
                        branchInfo: ''
                    }
                }
            })
            },
    }
}
</script>

<style>
.popper-class {
    z-index: 30021!important;
}
</style>
